import { DropdownButton, Dropdown } from "react-bootstrap";
import { DocumentSortMethod } from "../../../../models/document";

const SortingDropdown: React.FC<{
  selectedValue: DocumentSortMethod;
  onSelected: (val: DocumentSortMethod) => void;
}> = (props) => {

  return (
    
    <span className="sorting-container">
        
        <DropdownButton
        id="document-sort-method"
        variant="primary"
        title={!!props.selectedValue ? props.selectedValue  :  "Most Recent"}
        bsPrefix="sorting-btn"
        onSelect={(val) => {           
          if (!!val) {        
            props.onSelected(DocumentSortMethod[val as keyof typeof DocumentSortMethod])
          }
        }}      
      >
        {Object.keys(DocumentSortMethod).map((name) => {
          const text = DocumentSortMethod[name as keyof typeof DocumentSortMethod];
          
          return (
            <Dropdown.Item
              key={name}
              eventKey={name}
              value={name}
              bsPrefix="sorting-item"
              active={text.replaceAll(' ','') === props.selectedValue.replaceAll(' ','')}
            >
              {text}
            </Dropdown.Item>
          );
        })}
      </DropdownButton>
    </span>
  );
};

export default SortingDropdown;
